import { DialogConfig } from '@/shared/stores/useGlobalDialogStore';

export const errorRegistry: Record<string, DialogConfig> = {
	INSUFFICIENT_BALANCE: {
		title: 'Insufficient Balance',
		description:
			'You do not have enough credits. Please add more to continue.',
		variant: 'warning',
		primaryAction: {
			label: 'Go to Billing',
			handler: () => {
				window.location.href = '/settings?tab=billing&view=usage';
			},
		},
		secondaryAction: {
			label: 'Cancel',
			handler: () => {},
		},
	},
	ACCOUNT_NOT_FOUND: {
		title: 'Insufficient Balance',
		description:
			'You do not have enough credits. Please add more to continue.',
		variant: 'warning',
		primaryAction: {
			label: 'Go to Billing',
			handler: () => {
				window.location.href = '/settings?tab=billing&view=usage';
			},
		},
		secondaryAction: {
			label: 'Cancel',
			handler: () => {},
		},
	},
};
